import React from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';

import withApollo from '../lib/apollo';
import CaseStudy from '../components/News/Case';
import { useSiteContext } from '../components/SiteContext';
import articleQuery from '../lib/queries/news/articleQuery.graphql';
import {
  articleImageConfigurations,
  authorImageConfigurations,
} from '../lib/imageConfigurations';
import throw404 from '../lib/throw404';
import withQuery from '../lib/withQuery';

const caseStudies = {
  'fashionunited.in': { 'primark-sustainability': 15_133 },
};

const CaseStudyWithQuery = withQuery(CaseStudy);

const CaseStudyPage = ({ router }) => {
  const { slug } = router.query;
  const { prefix, newsboard } = useSiteContext();

  const site = { ...caseStudies[prefix] };
  const id = site[slug];

  if (!id) {
    return throw404();
  }

  return (
    <CaseStudyWithQuery
      query={articleQuery}
      variables={{
        newsboard,
        id,
        imageConfigurations: articleImageConfigurations,
        authorImageConfigurations,
      }}
      errorMessage="Error while loading article..."
    />
  );
};

CaseStudyPage.propTypes = {
  router: PropTypes.shape({
    query: PropTypes.shape({
      slug: PropTypes.string,
    }),
  }),
};

CaseStudyPage.defaultProps = {
  router: {},
};

export default withApollo(withRouter(CaseStudyPage));
